import { COLORS } from "@/constants";

export const NavigationArrowLeft = ({ disabled }: { disabled?: boolean }) => <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 7L9 12" stroke={disabled ? COLORS['neutral/700'] : "#fff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  <path d="M9 12L14 17" stroke={disabled ? COLORS['neutral/700'] : "#fff"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
</svg>
